export default __webpack_public_path__ + "static/media/Jump (12).fe632eb0.png";